import {
  mergeDeepRight, uniq, omit, fromPairs, pluck,
} from 'ramda';
import { createSlice } from '@reduxjs/toolkit';
import { AGENTS, LOGOUT_USER } from '../namespace';

const agentsList = (state = {
  byId: {},
  allIds: [],
}, { update, remove }) => {
  let result = state;
  if (update) {
    const pairs = update.map((agent) => [agent.id, agent]);
    result = {
      byId: mergeDeepRight(result.byId, fromPairs(pairs)),
      allIds: uniq([...result.allIds, ...pluck(0, pairs)]),
    };
  }
  if (remove) {
    const agentIds = remove.map((agent) => agent.id);
    result = {
      byId: omit(agentIds, result.byId),
      allIds: result.allIds.filter((id) => agentIds.indexOf(id) < 0),
    };
  }
  return result;
};

const agentsSlice = createSlice({
  name: AGENTS,
  initialState: {},
  reducers: {
    update: {
      reducer: (state, { payload }) => {
        state[payload.companyId] = agentsList(state[payload.companyId], payload);
      },
      prepare: ({ companyId, update = [], remove = [] }) => ({
        payload: { companyId, update, remove },
      }),
    },
  },
  extraReducers: (builder) => {
    builder.addCase(LOGOUT_USER, () => ({}));
  },
});

export const { update: updateAgents } = agentsSlice.actions;

export default { [AGENTS]: agentsSlice.reducer };
